import React from "react";
const SignUp: React.FC<{}> = () => {
    return (
        <div>
            <h1>sign up</h1>
        </div>
    )
}
export default SignUp;
